import React from 'react';
import { Row, Col, Alert, Button, ButtonToolbar } from 'react-bootstrap';
import DropDownInput from './common/DropDownInput.jsx';

export default class DownloadItemsComponent extends React.Component {

  componentDidMount() {
    this.props.findAllOrderIds();
  }

  componentWillUnmount() {
    this.props.cleanAlert();
  }

  render() {

    let generateItemsFile = () => {
      this.props.generateItemsFile(this.props.formBean);
    };

    let downloadLinkStyle = {
      display: this.props.formBean.get('outputFile') === '' ? 'none' : 'block'
    };

    let openPdf = () => {
      window.open(this.props.formBean.get('outputFile'));
    };

    let generateItemsFile2 = () => {
      this.props.generateItemsFile2(this.props.formBean);
    };

    let downloadLinkStyle2 = {
      display: this.props.formBean.get('outputFile2') === '' ? 'none' : 'block'
    };

    let openPdf2 = () => {
      window.open(this.props.formBean.get('outputFile2'));
    };

    let alertDiv = null;
    if (this.props.alertStyle || this.props.alertMessage) {
      alertDiv = (
        <Alert bsStyle={this.props.alertStyle} onDismiss={this.props.cleanAlert}>
          {this.props.alertMessage}
        </Alert>
      );
    }

    let showDownload1 = (this.props.showDownload1) ? '' : 'none';

    return (
      <div>
        <h4>下載出貨資料</h4>
        <Row>
          <Col xs={12} sm={6} md={6}>
            {alertDiv}
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col xs={12} sm={6} md={6}>
            <DropDownInput id="orderId"
              label="訂單編號"
              required="true"
              options={this.props.allOrderIds.map((value, key) => ({ label: value.get('order_id') + ' (' + value.get('shipment_display') + ')', value: value.get('order_id') })).toJS()}
              onChange={(id, value, label) => {
                this.props.setValue(id, value);
              }}
              validation={this.props.formBeanValidation.get('orderId')}
            />
          </Col>
        </Row>
        <div style={{display: showDownload1}}>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={generateItemsFile}>取得包裝出貨資料 (FDL)</Button>
              <Button style={downloadLinkStyle} bsStyle="default" onClick={openPdf}>下載包裝出貨資料</Button>
            </ButtonToolbar>
          </Col>
        </Row>
        <br />
        </div>
        <Row>
          <Col xs={12} sm={6} md={6}>
            <ButtonToolbar>
              <Button bsStyle="info" onClick={generateItemsFile2}>取得包裝出貨資料</Button>
              <Button style={downloadLinkStyle2} bsStyle="default" onClick={openPdf2}>下載包裝出貨資料</Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </div>
    )
  }
};


// WEBPACK FOOTER //
// ./src/components/DownloadItemsComponent.jsx